import { useAppDispatch, useAppSelector } from '@/redux/global-hooks';
import { selectPrizeManagement, setPiece, setPrize } from '@/redux/slices/prize_management.slice';

export default function usePrizeManagement() {
  const dispatch = useAppDispatch();
  const prizeManagement = useAppSelector(selectPrizeManagement);

  const setPrizeValue = (values) => dispatch(setPrize(values));
  const clearPrizeValue = () => dispatch(setPrize(null));
  const setPieceValue = (values) => dispatch(setPiece(values));
  const clearPieceValue = () => dispatch(setPiece(null));
  return {
    prizeManagement,
    setPrizeValue,
    clearPrizeValue,
    setPieceValue,
    clearPieceValue,
  };
}
